import { Component, inject, input, OnInit, output } from '@angular/core';
import { NbButtonModule, NbIconModule, NbInputModule } from '@nebular/theme';
import { MentionModule, Mentions } from 'angular-mentions';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { UsersService } from '../../../@core/utils';
import { KPI } from '../../../@core/api';
import { TranslateModule } from '@ngx-translate/core';


@Component({
  selector: 'app-comments',
  standalone: true,
  imports: [
    NbButtonModule,
    MentionModule,
    NbInputModule,
    NbIconModule,
    TranslateModule,
  ],
  templateUrl: './comments.component.html',
  styleUrls: ['./comments.component.scss'],
})
export class CommentsComponent implements OnInit {
  private _userService = inject(UsersService);

  canAddComment = input(true);

  content = output<string>();

  mentionConfig: Mentions = {
    triggerChar: '@',
    maxItems: 10,
    labelKey: 'name',
    dropUp: true,
    mentionFilter(searchString, items: KPI.User[]) {
      return items.filter((item) =>
        // find the user by email or by name
        item.name.toLowerCase().includes(searchString.toLowerCase()) || item.email.toLowerCase().includes(searchString.toLowerCase()),
      );
    },
    mentionSelect(item: KPI.User) {
      return '@' + item.email;
    },
  };
  // list of all users for mentions
  mentions = toSignal(this._userService.mentions$.pipe(takeUntilDestroyed()), { initialValue: [] });

  ngOnInit(): void {
  }


  onSubmit(content: HTMLTextAreaElement) {
    content && this.content.emit(content.value);
    // reset the content value
    content.value = '';
  }
}
